import React from 'react';
import SubServices from '../common/sub-services';

const CmsServies = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Let&apos;s Find Out Why CMS Development Is Highly in Demand
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 lg:w-8/12 mx-auto">
                    <SubServices
                        path={'/img/technology/ic-webapp.svg'}
                        height={64}
                        width={64}
                        alt="consult"
                        title="consult"
                        serviceName="Highly Customizable"
                        serviceDescription="When it comes to customization, whether it's Drupal, Magento, WordPress, or OpenCart, Content management system (CMS) is highly customizable in terms of features, designs, modules, or layouts."
                    />
                    <SubServices
                        path={'/img/technology/ic-spas.svg'}
                        height={64}
                        width={64}
                        alt="development"
                        title="development"
                        serviceName="Fully Flexible"
                        serviceDescription="Whether it’s WordPress or Magento, the majority of CMS frameworks allow extending websites with the integration of powerful and event-driven plugins and extensions that would otherwise be very hard to build."
                    />
                    <SubServices
                        path={'/img/technology/ic-ecommerce-development.svg'}
                        height={64}
                        width={64}
                        alt="spas"
                        title="spas"
                        serviceName="Powerful & Scalable"
                        serviceDescription="CMS Development is a great choice for creating a robust custom content management system that facilitates the dynamic needs of business organizations."
                    />
                    <SubServices
                        path={'/img/technology/ic-mobile-app.svg'}
                        height={64}
                        width={64}
                        alt="portaldevelopment"
                        title="portaldevelopment"
                        serviceName="Highly Extensible"
                        serviceDescription="With thousands of free plugins and extensions available along with multiple inbuilt API support, the development of scalable and rich-featured websites is easier with CMS."
                    />
                </div>
            </div>
        </div>
    );
};

export default CmsServies;
